import { lazy } from 'react';

// CONSTANTS
import * as routePaths from '@/constants/routes';

// UTILITY
import { retry } from '@/utility/routes';

// COMPONENTS
const SignIn = lazy(() => retry(() => import('@/containers/Auth/SignIn')));
const SignInWithAuth0 = lazy(() => retry(() => import('@/containers/Auth/SignInWithAuth0')));
const ResetPassword = lazy(() => retry(() => import('@/containers/Auth/ResetPassword')));
const UpdatePassword = lazy(() => retry(() => import('@/containers/Auth/UpdatePassword')));
const RootPrivate = lazy(() => retry(() => import('@/containers/RootPrivate')));
const Overview = lazy(() => retry(() => import('@/containers/Overview')));
const Reports = lazy(() => retry(() => import('@/containers/Reports')));
const ReportDetails = lazy(() => retry(() => import('@/containers/Reports/ReportDetails')));
const SROverview = lazy(() => retry(() => import('@/containers/SRReports/SROverview')));
const SRInvitedUsers = lazy(() => retry(() => import('@/containers/SRReports/SRInvitedUsers')));
const SRUserDetails = lazy(() => {
  return retry(() => import('@/containers/SRReports/SRInvitedUsers/SRUserDetails'));
});
const SRTransactionOverview = lazy(() => {
  return retry(() => import('@/containers/SRReports/Transaction/TransactionOverview'));
});
const SRReport = lazy(() => retry(() => import('@/containers/SRReports/SRReport')));
const Users = lazy(() => retry(() => import('@/containers/Users')));
const Profiles = lazy(() => retry(() => import('@/containers/Profiles')));
const PartnerAssets = lazy(() => retry(() => import('@/containers/PartnerAssets')));
const Webhooks = lazy(() => retry(() => import('@/containers/Webhooks')));
const StreamingAdvice = lazy(() => retry(() => import('@/containers/StreamingAdvice')));
const StyleGuide = lazy(() => retry(() => import('@/containers/StyleGuide')));
const Settings = lazy(() => retry(() => import('@/containers/Settings')));

export const getRoutes = () => {
  return [
    // Auth
    { path: routePaths.ROUTE_ROOT, type: 'auth', component: SignIn },
    { path: routePaths.ROUTE_AUTH0_CALLBACK, type: 'auth', component: SignInWithAuth0 },
    { path: routePaths.ROUTE_RESET_PASSWORD, type: 'auth', component: ResetPassword },
    { path: routePaths.ROUTE_UPDATE_PASSWORD, type: 'auth', component: UpdatePassword },
    { path: routePaths.ROUTE_CREATE_PASSWORD, type: 'auth', component: UpdatePassword },

    // -- DASHBOARD --
    // Root private
    {
      path: routePaths.ROUTE_ROOT_PRIVATE,
      component: RootPrivate,
      type: 'dashboard',
      protection: true,
    },
    // Overview
    {
      path: routePaths.ROUTE_OVERVIEW,
      component: Overview,
      type: 'dashboard',
      protection: true,
    },
    // Reports
    {
      path: routePaths.ROUTE_REPORTS,
      component: Reports,
      type: 'dashboard',
      protection: true,
    },
    {
      path: routePaths.ROUTE_REPORT_DETAILS,
      component: ReportDetails,
      type: 'dashboard',
      protection: true,
    },
    // SR Reports
    {
      path: routePaths.ROUTE_SR_OVERVIEW,
      component: SROverview,
      type: 'dashboard',
      protection: true,
      componentProps: {
        slug: 'overview',
      },
    },
    {
      path: routePaths.ROUTE_SR_USERS,
      component: SRInvitedUsers,
      type: 'dashboard',
      protection: true,
      componentProps: {
        slug: 'users',
      },
    },
    {
      path: routePaths.ROUTE_SR_USER_DETAILS,
      component: SRUserDetails,
      type: 'dashboard',
      protection: true,
    },
    {
      path: routePaths.ROUTE_SR_TRANSACTION_OVERVIEW,
      component: SRTransactionOverview,
      type: 'dashboard',
      protection: true,
      componentProps: {
        slug: 'sc-transactions-overview',
      },
    },
    {
      path: routePaths.ROUTE_SR_REPORT,
      component: SRReport,
      type: 'dashboard',
      protection: true,
    },
    // Users
    {
      path: routePaths.ROUTE_USERS,
      component: Users,
      type: 'dashboard',
      protection: true,
    },
    // MB Users
    {
      path: routePaths.ROUTE_PROFILES,
      component: Profiles,
      type: 'dashboard',
      protection: true,
    },
    // Settings
    {
      path: routePaths.ROUTE_SETTINGS,
      component: Settings,
      type: 'dashboard',
      protection: true,
    },
    // Partner Assets
    {
      path: routePaths.ROUTE_WP_PAGE,
      component: PartnerAssets,
      type: 'dashboard',
      protection: true,
    },
    // Webhooks
    {
      path: routePaths.ROUTE_WEBHOOKS,
      component: Webhooks,
      type: 'dashboard',
      protection: true,
    },
    //  Streaming Advice
    {
      path: routePaths.ROUTE_STREAMING_ADVICE,
      component: StreamingAdvice,
      type: 'dashboard',
      protection: true,
    },

    // -- STATIC PAGES --
    {
      path: routePaths.ROUTE_STYLEGUIDE,
      component: StyleGuide,
    },
  ];
};

export default getRoutes;
